

import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useAuth } from '../../../../hooks/useAuth';
import { Button, Grid, IconButton, Rating, Typography } from '@mui/material';
import {NotificationManager} from 'react-notifications';
import moment from "moment-jalaali";
import PropTypes from 'prop-types';
import SendIcon from '@mui/icons-material/Send';
import { CssTextField } from '../../elements';
import { setSellWorkVote } from '../../../../services/material-services';
import StarIcon from '@mui/icons-material/Star';
import { blue } from '@mui/material/colors';


const labels = {
  0.5: 'خیلی ضعیف',
  1: 'بی فایده',
  1.5: 'ضعیف',
  2: 'پایین',
  2.5: 'معمولی',
  3: 'بهتر',
  3.5: 'خوب',
  4: 'بسیار خوب',
  4.5: 'عالی',
  5: 'بسیار عالی',
}

function getLabelText(value) {
    return `${labels[value]}`
}

function Row(props) {
    const { authData } = useAuth()
    const { row, onClose, title, isAdmin } = props
    const [open, setOpen] = useState(false)
    const [comment, setComment] = useState()
    const [commentVote, setCommentVote] = useState()
    const [hover, setHover] = React.useState(-1)

    
    // useEffect(() => {

    //   console.log("Row", title, row)
    // }, [row, title])
    
    const handleClose = (value) => {
        if(isAdmin){
            onClose(value)
        }
    }

  const handlerComment = () => {
      // console.log(comment)
      setSellWorkVote(authData.token, 
            {
                user: authData.user.id, 
                sell_work: row.id,
                description:comment, 
                vote: commentVote
            }).then(resp => {
              setComment('')
              row?.sell_detail_work_votes.unshift(resp)
              NotificationManager.success('جزئیات جدید به برنامه اضافه شد')
            }).catch(err=>{
                NotificationManager.error('متاسفانه خطایی در زمان ثبت جزئیات وجود دارد')
            })  
  }
  
  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset', backgroundColor: 'pink.text' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell 
            component="th" 
            scope="row" 
            sx={{textAlign: 'center'}}
            >
            <Button onClick={() => handleClose(row)}>
                <Typography 
                    fontFamily='b_mitra' 
                    component="b"
                    variant="h6"
                    color='secondary'
                    noWrap
                    >
                    {title}
                </Typography>
            </Button>
        </TableCell>
        <TableCell align="right" sx={{textAlign: 'center'}}>
            <Typography 
                fontFamily='b_mitra' 
                component="b"
                variant="b"
                color={blue[900]}
                >
                  {row.user_work.name}
                
            </Typography>
        </TableCell>
        <TableCell align="right" sx={{textAlign: 'center'}}>
            <Typography 
                fontFamily='b_mitra' 
                component="b"
                variant="b"
                color={blue[900]}
                >
                  {row.project_progress}
            </Typography>
        </TableCell>
        <TableCell align="right" sx={{textAlign: 'center'}}>
            <Typography 
                fontFamily='b_mitra' 
                component="b"
                variant="b"
                color={blue[900]}
                >
                  {row.projectstatus}
            </Typography>
        </TableCell>
        <TableCell align="right" sx={{textAlign: 'center'}}>
            <Typography 
                fontFamily='b_mitra' 
                component="b"
                variant="b"
                color={blue[900]}
                noWrap
                >
                {row.remarks}
            </Typography>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1, backgroundColor:blue[700] }}>
                <Typography 
                    fontFamily='b_mitra' 
                    gutterBottom 
                    component="b"
                    variant="h6"
                    color={'white'}
                    >
                  نظرات:
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{textAlign: 'center'}}>
                          <Typography
                              fontFamily='b_mitra' 
                              component="b"
                              variant="b"
                              color={'white'}
                              >
                              توضیحات
                          </Typography>
                      </TableCell>
                      <TableCell sx={{textAlign: 'center'}}>
                          <Typography
                              fontFamily='b_mitra' 
                              component="b"
                              variant="b"
                              color={'white'}
                              >
                              امتیاز
                          </Typography>
                      </TableCell>
                      <TableCell align="right" sx={{textAlign: 'center'}}>
                          <Typography
                              fontFamily='b_mitra' 
                              component="b"
                              variant="h7"
                              color={'white'}
                              >
                              زمان
                          </Typography>
                      </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                  {row?.sell_detail_work_votes && row?.sell_detail_work_votes?.map((historyRow) => (
                    <TableRow key={historyRow?.id} sx={{backgroundColor: 'pink.text'}}>
                        <TableCell 
                            component="div" 
                            scope="row"
                            sx={{textAlign: 'center'}}
                          >
                          <Typography
                              fontFamily='b_mitra' 
                              component="div"
                              variant="div"
                              color={blue[900]}
                              >
                                {historyRow?.description}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{textAlign: 'center'}}>
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant="div"
                                color={blue[900]}
                                >
                                {getLabelText(historyRow?.vote)}
                            </Typography>
                        </TableCell>
                        <TableCell align="right" sx={{textAlign: 'center'}}>
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant="div"
                                color={blue[900]}
                                >
                                {moment(historyRow?.time, 'YYYY-M-D HH:mm').format('jYYYY/jM/jD HH:mm')}
                            </Typography>
                        </TableCell>
                    </TableRow>
                  ))}
                  <div >
                      <Box
                        
                          sx={{
                            width: 200,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                        <Rating
                            name="hover-feedback"
                            value={commentVote}
                            precision={0.5}
                            getLabelText={getLabelText}
                            onChange={(event, newValue) => {
                                setCommentVote(newValue)
                            }}
                            onChangeActive={(event, newHover) => {
                              setHover(newHover)
                            }}
                            emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit"/>}
                          />
                          {commentVote !== null && (
                            <Box sx={{ ml: 2, color: 'white' }}>{labels[hover !== -1 ? hover : commentVote]}</Box>
                          )}
                      </Box>
                      <Grid container spacing={1} alignItems='flex-end'>
                          <Grid item>
                              <SendIcon 
                                  sx={{ color: 'pink.text', mr: 1, my: 0.5 }} 
                                  onClick={handlerComment}/>
                          </Grid>
                          <Grid item xs={10}>
                              <CssTextField  
                                  label={(
                                      <Typography 
                                          fontFamily='b_mitra' 
                                          component="div"
                                          variant="h6"
                                          color={'pink.text'}
                                          >
                                            پیام
                                      </Typography>
                                  )}
                                  backgroundColor={blue[900]}
                                  fullWidth
                                  multiline
                                  inputProps={{ style: { color: blue[900], backgroundColor: 'white' } }}
                                  variant="standard" value={comment}
                                  onChange={ e => setComment( e.target.value )} />
                          </Grid>
                      </Grid>
                  </div>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  )
}

Row.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  // selectedValue: PropTypes.string.isRequired,
}

export default function SellWork({userClient, ReqUser}) {
    const { authData } = useAuth()
    const [isAdmin, setIsAdmin] = useState(false)
    // const [loading, setLoading] = useState(false)
    // const [dataUserReq, setDataUserReq] = useState()
    const [bioStep, setBioStep] = useState()
    const [dateExpire, setDateExpire] = useState()
    const [detailID, setDetailID] = useState(0)

    // const getData = async() =>{
    //     await getWorkList(authData?.token, ReqUser.id)
    //     .then(data => {
            
    //         // console.log("getWorkList", data?.results)
    //         setDataUserReq(data?.results)
            
    //         // setUserClient(data?.results)

    //         setLoading(false)
    //     }).catch( e => {
    //         setError(true)
    //         setLoading(false)
    //     })
    // }
    useEffect(()=>{
        // console.log("SellWork", ReqUser.sell_req_buys.sell_mats)
        if(authData?.user){
            setIsAdmin(authData.user?.profile?.is_permium)
        }
        
    }, [authData])

    const handleClose =  value => {
        // e.preventDefault()
        // console.log("handleClose", value?.bio_step, value?.expire_time)
        setBioStep(value?.bio_step)
        setDateExpire(value?.expire_time)
        setDetailID(value?.id)
        // setSelectedValue(value)
    }

  return (
    <React.Fragment>
      <div>
          <TableContainer component={Paper} sx={{backgroundColor: blue[900]}}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <TableCell />
                    <TableCell sx={{textAlign: 'center'}}>
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            color={'pink.text'}
                            >
                            نام مرحله
                        </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{textAlign: 'center'}}>
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            color={'pink.text'}
                            >
                            نام طراح
                        </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{textAlign: 'center'}}>
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            color={'pink.text'}
                            >
                            درصد پیشرفت
                        </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{textAlign: 'center'}}>
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            color={'pink.text'}
                            >
                            وضعیت
                        </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{textAlign: 'center'}}>
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            color={'pink.text'}
                            >
                            توضیحات
                        </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ReqUser?.sell_req_buys?.sell_mats.map(rowMain => (
                    rowMain.sell_detail_works?.map(row => (
                        <Row 
                            key={row.id} 
                            row={row} 
                            onClose={handleClose} 
                            title={rowMain.bio_step}
                            isAdmin={isAdmin}
                            />
                    ))
                  ))}
                </TableBody>
              </Table>

          </TableContainer>
      </div>
      </React.Fragment>
    )
}